import { baseURL } from "./config";

export default async function sendVerificationCode({ phone }) {
  // Create the user
  const response = await fetch(baseURL + "/validation/start", {
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmdhbml6YXRpb24iOiJSQVNUUkVBVE9SIn0.OGp_G6Lref09-YkoRsY3vBUEndMpAbhUR-tHHu-nlm4",
    },
    method: "POST",
    body: JSON.stringify({ phone }),
  });

  const data = await response.json();

  return data;
}
